<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import PageProgressBar from './parts/PageProgressBar.vue';
import AppFooter from './parts/AppFooter.vue';
import { useAppStateStore } from '@/js/core/stores/app-state-store';
import { useCurrentPageStore } from '@/js/core/stores/current-page-store';
import { useTimezoneStore } from '@/js/core/stores/timezone-store';
import LivestreamHud from '@/js/core/components/parts/livestream/LivestreamHud.vue';
import { useAppHydration } from '@/js/core/composables/useAppHydration';
import { useBodyDatasetSync } from '@/js/core/composables/useBodyDatasetSync';
import { useTimezoneGradientOffset } from '@/js/core/composables/useTimezoneGradientOffset';

const props = defineProps({
  appConfiguration: { type: Object, default: () => ({}) },
  currentPage: { type: Object, default: () => ({}) },
  userData: { type: Object, default: () => ({}) },
});

const appStateStore = useAppStateStore();
const currentPageStore = useCurrentPageStore();
const timezoneStore = useTimezoneStore();
const route = useRoute();

const showFooter = computed(() => route.name !== 'digital-display-events');

const { hydrateAppStores } = useAppHydration(props);
const { startTimezoneClock, updateGradientOffset } = useTimezoneGradientOffset(timezoneStore);
const { syncInitialTimezoneDataset } = useBodyDatasetSync(
  route,
  currentPageStore,
  timezoneStore,
  appStateStore
);

onMounted(() => {
  hydrateAppStores();
  timezoneStore.hydrateFromProfile(window.gsdNowAppData?.currentProfile ?? null);
  syncInitialTimezoneDataset();
  startTimezoneClock();
  updateGradientOffset();
});
</script>

<template>
  <PageProgressBar />

  <RouterView name="modal" />
  <RouterView />
  <LivestreamHud v-if="appStateStore.livestreamHudEnabled" />
  <AppFooter v-if="showFooter" />
</template>
